import type { DmpQuoteV2 } from '@/api/dmpV2.api';
const PREFIX = 'dmp.v2.checkout.';
export interface PendingCheckout {
  version: 1;
  owner: string;
  product: string;
  quote: DmpQuoteV2;
  key: string;
  attempted: boolean;
  orderId?: number;
}
const storageKey = (owner: string, product: string) => PREFIX + owner + '.' + product;
// 僅列入既有 attempt 查找後、新 attempt 建立前的明確拒絕。
// checkout_disabled 也可能來自已持久化但尚未送出的 attempt，不可清除其原 key。
export const rejectedBeforeAttempt = (code?: string): boolean =>
  ['dmp_quote_expired', 'dmp_quote_changed', 'dmp_service_runtime_unavailable', 'dmp_purchase_in_progress', 'dmp_pending_purchase_required_review'].includes(
    code || ''
  );
export function readCheckout(owner: string, product: string): PendingCheckout | null {
  try {
    const raw = sessionStorage.getItem(storageKey(owner, product));
    if (!raw) return null;
    const p = JSON.parse(raw) as PendingCheckout;
    if (
      p.version !== 1 ||
      p.owner !== owner ||
      p.product !== product ||
      p.quote?.product_code !== product ||
      typeof p.quote.quote_id !== 'string' ||
      !/^[a-f0-9]{32}$/.test(p.key)
    )
      return null;
    return p;
  } catch {
    return null;
  }
}
export function saveCheckout(p: PendingCheckout): void {
  sessionStorage.setItem(storageKey(p.owner, p.product), JSON.stringify(p));
}
export function removeCheckout(owner: string, product: string): void {
  try {
    sessionStorage.removeItem(storageKey(owner, product));
  } catch {
    /* 無儲存資料時不重建付款。 */
  }
}
export function clearCheckouts(): void {
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const k = sessionStorage.key(i);
      if (k?.startsWith(PREFIX)) sessionStorage.removeItem(k);
    }
  } catch {
    /* 不保留跨帳號付款資訊。 */
  }
}
